import NewReportForm from './NewReportForm';

export default NewReportForm;
